import { useEffect, useRef, useState } from "react";
import { adminUrl } from "../../public/src/urls";
import PropTypes from "prop-types";
import useWindowSize from "../components/useWindowSize";
import { CurrencyConverter } from "../components/Currency";
import { CartController } from "../cart/CartController";
import "./galeries.css";
import { IoTrashBin } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { fetchGet } from "../fetchData/fetchGet";
import { fetchAdd } from "../fetchData/fetchAdd";
import { fetchDelete } from "../fetchData/fetchDelete";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import {
  handelAddWishList,
  handelRemoveWishList,
} from "../components/useWishlist";

export const ProductSection = ({ Product, ShopInfo, isLogedIn }) => {
  const { isMobile } = useWindowSize();
  const [mainPhoto, setMainPhoto] = useState(Product.Photo);
  const [zoomStyle, setZoomStyle] = useState({});
  const [SizeQuantity, setSizeQuantity] = useState(0);
  const imgRef = useRef(null);
  const handlePhotoClick = (e) => {
    setMainPhoto(e);
  };
  const [ProductGaleries, setProductGaleries] = useState([]);
  const [ProductInfos, setProductInfos] = useState([]);
  useEffect(() => {
    const fetchedProductGaleries = async () => {
      try {
        const ProductGaleriess = Product.details
          ? await JSON.parse(Product.details)
          : [];
        const ProductInfoss = Product.info
          ? await JSON.parse(Product.info)
          : [];

        setProductInfos(ProductInfoss);
        setProductGaleries(ProductGaleriess);
      } catch (err) {
        console.error("Failed to fetch products" + err);
      }
    };
    fetchedProductGaleries();
    setMainPhoto(Product.Photo);
  }, [Product]);

  const [Wishlist, setWishlist] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        const Gwishlist = await fetchGet("TB_WishList");
        setWishlist(Gwishlist);
      } catch (error) {
        console.error(error);
      }
    };
    fetchWishlist();
  }, []);
  const sliderRef = useRef(null);
  const imageRefs = useRef([]);

  const handleImageClick = (index) => {
    // Handle the photo click action
    handlePhotoClick(ProductGaleries[index].Photo);

    // If it's the last visible image, scroll to the next one
    if (imageRefs.current[index + 1]) {
      if (isMobile) imageRefs.current[index + 1];
      else
        imageRefs.current[index + 1]({
          behavior: "smooth",
          block: "start",
        });
    }
    if (imageRefs.current[index - 1]) {
      if (isMobile) imageRefs.current[index - 1];
      //   else
      //     imageRefs.current[index - 1].scrollIntoView({
      //       behavior: "smooth",
      //       block: "start",
      //     });
      // imageRefs.current[index - 1]
      // .scrollIntoView({ behavior: 'smooth',block: 'start', });
    }
  };
  const [backgroundPosition, setBackgroundPosition] = useState("center");
  const [isZoomed, setIsZoomed] = useState(false);

  const handleMouseMove = (e) => {
    const { left, top, width, height } =
      e.currentTarget.getBoundingClientRect();
    const x = ((e.pageX - left) / width) * 100;
    const y = ((e.pageY - top) / height) * 100;
    setBackgroundPosition(`${x}% ${y}%`);
  };

  //   const handleMouseMove = (e) => {
  //     const { left, top, width, height } =
  //       e.currentTarget.getBoundingClientRect();
  //     const x = ((e.pageX - left) / width) * 100;
  //     const y = ((e.pageY - top) / height) * 100;
  //     setBackgroundPosition(`${x}% ${y}%`);
  //   };

  const groupedByDescr = ProductInfos?.filter((prod) => prod.Qty > 0).reduce(
    (acc, product) => {
      // If the 'Descr' group doesn't exist, create it
      if (!acc[product.Descr]) {
        acc[product.Descr] = [];
      }
      // Add the product to the appropriate Descr group
      acc[product.Descr].push(product);
      return acc; // Return the accumulator to continue reducing
    },
    {}
  );
  const [color, setColor] = useState("");
  const [size, setSize] = useState("");
  const [photo, setPhoto] = useState("");
  const [Qty, setQty] = useState("1");
  const [isAdded, setISadded] = useState(false);
  const [ColorSelected, setColorSelected] = useState(false);
  const [Error, setError] = useState("");
  const [HasColor, setHasColor] = useState(false);
  const [HasPhoto, setHasPhoto] = useState(false);
  const [ColorQuantity, setColorQuantity] = useState(false);
  const cart = JSON.parse(localStorage.getItem("cart")) || [];

  const handelSelectPhotoColor = async (ProductInfo) => {
    const cartOrder = cart
      .filter(
        (ord) =>
          ord.ProductID === Product.ProductID &&
          ord.color === ProductInfo.color &&
          ord.size === ProductInfo.Descr
      )
      .reduce((total, item) => total + Number(item.Qty), 0);
    const Quantity = ProductInfo.Qty - cartOrder;

    setSizeQuantity(Quantity);
    // setSizeQuantity(ProductInfo.Qty);
  };
  const handelSelectSize = async (ProductInfo) => {
    const Available = groupedByDescr[ProductInfo];
    const cartOrder = cart
      .filter(
        (ord) =>
          ord.ProductID === Product.ProductID && ord.size === Available[0].Descr
      )
      .reduce((total, item) => total + Number(item.Qty), 0);
    const Quantity =
      Available.reduce((total, item) => total + item.Qty, 0) - cartOrder;

    const hasColor = await Available.some(
      (item) => item.color && item.color !== ""
    );
    setHasColor(hasColor);
    const hasPhoto = await Available.some(
      (item) => item.Photo && item.Photo !== ""
    );
    setHasPhoto(hasPhoto);

    setSize(ProductInfo);
    setColor("");
    setColorSelected("");
    setError("");
    setSizeQuantity(Quantity);
    setQty("1");
  };
  const handelAdeedToCart = () => {
    if (ProductInfos.length > 0) {
      const sizeCount = ProductInfos.reduce((count, product) => {
        if (product.Descr && product.Descr.trim() !== "") {
          return count + 1;
        }
        return count;
      }, 0);

      if (sizeCount > 0 && size === "") {
        setError("Please select a size...");
        return false;
      }

      if (HasColor && HasPhoto) {
        if (color === "" && photo === "") {
          setError("Please select a color or photo ...");
          return false;
        }
      }
      if (!HasPhoto && HasColor > 0 && color === "") {
        setError("Please select a color...");
        return false;
      }

      if (!HasColor && HasPhoto > 0 && photo === "") {
        setError("Please select a photo...");
        return false;
      }
      // return false;
    }

    const newItemAdded = {
      ProductID: Product.ProductID,
      Price: Product.HasDiscount ? Product.DiscountPrice : Product.Price,
      Image: Product.Photo,
      Product: Product,
      color: color,
      size: size,
      photo: photo,
      Qty: Qty,
    };
    cart.push(newItemAdded);

    localStorage.setItem("cart", JSON.stringify(cart));

    setISadded(true);
    setSizeQuantity(SizeQuantity - Qty);
    setTimeout(() => {
      setISadded(false);
    }, 5000);
  };
  return (
    <section>
      <div
        className={isAdded ? "added-notification show " : "added-notification "}
      >
        <img src={adminUrl + Product.Photo} className="img-fluid" alt="" />
        <h3>added to cart</h3>
      </div>
      <div className="collection-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-1 col-sm-2 col-xs-12">
              <div className="row">
                <div className="col-12 p-0">
                  <div
                    className={
                      isMobile
                        ? "slider-right-nav-row"
                        : "slider-right-nav-column"
                    }
                    ref={sliderRef}
                  >
                    {ProductGaleries &&
                      ProductGaleries.map((galery, i) => (
                        <div
                          key={i}
                          className="m-1 carousel-img"
                          ref={(el) => (imageRefs.current[i] = el)}
                          style={
                            isMobile
                              ? {
                                  width: "30%",
                                  height: "30%",
                                  padding: "4%",
                                  float: "left",
                                  // overflowY: "scroll",
                                  // overflowX: "scroll",
                                  overflow: "hidden",
                                }
                              : {}
                          }
                        >
                          <LazyLoadImage
                            src={galery.Photo ? adminUrl + galery.Photo : ""}
                            effect="blur"
                            onClick={() => handleImageClick(i)}
                            style={{ height: "50px" }}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="col-lg-5 col-sm-10 col-xs-12 flex flex-row items-center justify-start gap-4">
              <div className="border border-blue-500 p-2">aa</div>
              <div className="border border-green-500 p-2">aa</div>
            </div> */}
            <div
              className="col-lg-4 col-sm-10 col-xs-12  "
              style={{
                zIndex: isZoomed && isMobile && "9999",
              }}
            >
              <LazyLoadImage
                src={`${adminUrl}/${mainPhoto}`}
                effect="blur"
                ref={imgRef}
                onMouseMove={handleMouseMove}
                onMouseEnter={() => setIsZoomed(true)}
                onMouseLeave={() => setIsZoomed(false)}
                style={{
                  width: "350px",
                  cursor: "zoom-in",
                  // transform: isZoomed && isMobile && "scale(4)",
                  // transformOrigin: isZoomed && isMobile && backgroundPosition,
                  // transition: isZoomed && isMobile && "transform 0.3s ease",
                }}
              />
            </div>
            {isZoomed && !isMobile && (
              <div
                style={{
                  position: "fixed",
                  right: 50,
                  width: "55vw",
                  height: "60vh",
                  overflow: "hidden", // Prevents zoom overflow
                  zIndex: "9999",
                  border: "1px solid #ccc", // Optional: border for clarity
                  backgroundColor: "#fff",
                }}
              >
                <LazyLoadImage
                  src={`${adminUrl}/${mainPhoto}`}
                  effect="blur"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    transform: "scale(4)",
                    transformOrigin: backgroundPosition,
                    transition: "transform 0.3s ease",
                  }}
                />
              </div>
            )}
            {/* </div> */}
            {/* </div> */}
            {/* </div> */}

            <div className="col-lg-4">
              <div className="product-right product-description-box">
                {/* <div className="product-count">
                  <ul>
                    <li>
                      <img
                        src="src/assets/images/fire.gif"
                        className="img-fluid"
                        alt="image"
                      />
                      <span className="p-counter">37</span>
                      <span className="lang">orders in last 24 hours</span>
                    </li>
                    <li>
                      <img
                        src="src/assets/images/person.gif"
                        className="img-fluid user_img"
                        alt="image"
                      />
                      <span className="p-counter">44</span>
                      <span className="lang">active view this</span>
                    </li>
                  </ul>
                </div> */}
                <h2>{Product.ProductName}</h2>
                <div className="border-product">
                  <h6 className="product-title">product details</h6>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: Product.ProductDetails
                        ? Product.ProductDetails.substring(0, 500)
                        : "",
                    }}
                  />
                  {/* <p>
                  // {Product.ProductDetails}
                  </p> */}
                </div>
                <div className="single-product-tables border-product detail-section">
                  <table>
                    <tbody>
                      <tr>
                        <td>Shipping </td>
                        <td>{ShopInfo.ShippingInfo}</td>
                      </tr>
                      <tr>
                        <td>Shipping Info:</td>
                        <td>{ShopInfo.txtShipInfo}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="border-product">
                  <h6 className="product-title">100% SECURE PAYMENT</h6>
                  <div className="payment-card-bottom">
                    <ul>
                      <li>
                        <a>
                          <img src="src/assets/images/icon/visa.png" alt="" />
                        </a>
                      </li>
                      <li>
                        <a>
                          <img
                            src="src/assets/images/icon/mastercard.png"
                            alt=""
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="product-right product-form-box">
                {Product.HasDiscount ? (
                  <h4>
                    <del> {CurrencyConverter(Product.Price)} </del>
                    <span>
                      {(
                        (Product.DiscountPrice * 100) / Product.Price -
                        100
                      ).toFixed(1)}{" "}
                      %
                    </span>
                  </h4>
                ) : (
                  ""
                )}
                <h3 style={{ color: "#F1654C" }}>
                  {Product.HasDiscount
                    ? CurrencyConverter(Product.DiscountPrice)
                    : Product.Price > 0
                    ? CurrencyConverter(Product.Price)
                    : ""}
                  {/* id {Product.ProductID} */}
                </h3>
                <ul className="color-variant">
                  {ProductInfos &&
                    ProductInfos.filter(
                      (prod) =>
                        (prod.color || prod.Photo) &&
                        prod.Qty > 0 &&
                        prod.Descr === size
                    ).map((ProductInfo, i) => (
                      <li
                        key={i}
                        style={{
                          backgroundImage:
                            ProductInfo.Photo &&
                            `url("${adminUrl}/${Product.Photo}")`,
                          backgroundColor: ProductInfo.color
                            ? ProductInfo.color
                            : "",
                          display:
                            ProductInfo.color === "" && ProductInfo.Photo === ""
                              ? "none"
                              : "",
                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",
                          height: ColorSelected === i ? "50px" : "",
                          width: ColorSelected === i ? "50px" : "",
                          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                        onClick={() =>
                          ProductInfo.Photo
                            ? setPhoto(ProductInfo.Photo) +
                              setError("") +
                              setColor("") +
                              setColorSelected(i) +
                              handelSelectPhotoColor(ProductInfo)
                            : setColor(ProductInfo.color) +
                              setError("") +
                              setPhoto("") +
                              setColorSelected(i) +
                              handelSelectPhotoColor(ProductInfo)
                        }
                      ></li>
                    ))}
                </ul>

                <div
                  id="selectSize"
                  className="addeffect-section product-description border-product"
                >
                  {ProductInfos.every(
                    (info) => info.Descr !== "" || info.Descr !== "null"
                  ) && <h6 className="product-title">select size</h6>}

                  <h6 className="error-message">please select size</h6>
                  <div className="size-box">
                    <ul>
                      {groupedByDescr &&
                        Object.keys(groupedByDescr).map((ProductInfo, i) =>
                          ProductInfo ? (
                            <li
                              key={i}
                              style={{
                                borderRadius: "20%",
                                width: "auto",
                                padding: "5%",
                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                margin: "3px",
                              }}
                              onClick={() => handelSelectSize(ProductInfo)}
                              className={ProductInfo === size && "active"}
                            >
                              <a>{ProductInfo}</a>
                            </li>
                          ) : null
                        )}
                    </ul>
                  </div>
                  <h6 className="product-title">quantity</h6>
                  {SizeQuantity > 0 ? (
                    <>
                      <h6>Available {SizeQuantity}</h6>
                      <div className="qty-box">
                        <CartController
                          setQty={setQty}
                          Available={SizeQuantity}
                        />
                      </div>
                    </>
                  ) : (
                    size && (
                      <>
                        Size{" "}
                        <span
                          className="product-title mx-1"
                          style={{
                            fontWeight: "bold",
                            size: "16px",
                            color: "red",
                          }}
                        >
                          {" "}
                          {size}
                        </span>{" "}
                        Out Of Stock
                      </>
                    )
                  )}
                </div>

                <h4>{Error}</h4>
                <div className="product-buttons">
                  {ProductInfos.length > 0 && (
                    <a
                      id="cartEffect"
                      className="btn btn-solid hover-solid btn-animation"
                      onClick={handelAdeedToCart}
                    >
                      add to cart
                    </a>
                  )}
                  <a
                    // className="btn btn-solid"
                    className={
                      Wishlist &&
                      Wishlist.some(
                        (wish) => wish.ProductID === Product.ProductID
                      )
                        ? "btn mt-4"
                        : "btn btn-solid mt-4"
                    }
                    onClick={() =>
                      Wishlist &&
                      Wishlist.some(
                        (wish) => wish.ProductID === Product.ProductID
                      )
                        ? handelRemoveWishList(
                            Product,
                            isLogedIn,
                            Wishlist,
                            setWishlist,
                            navigate
                          )
                        : handelAddWishList(
                            Product,
                            isLogedIn,
                            Wishlist,
                            setWishlist,
                            navigate
                          )
                    }
                  >
                    {Wishlist &&
                    Wishlist.some(
                      (wish) => wish.ProductID === Product.ProductID
                    ) ? (
                      <div className="flex gap-2">
                        <IoTrashBin size={24} /> wishlist
                      </div>
                    ) : (
                      "wishlist"
                    )}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

ProductSection.propTypes = {
  Product: PropTypes.object.isRequired,
  ShopInfo: PropTypes.object.isRequired,
  isLogedIn: PropTypes.object.isRequired,
};
ProductSection.defaultProps = {
  Product: {},
  ShShopInfoop: {},
};
